// Built using https://www.tiny.cloud/docs/configure/content-filtering/#valid_elements
const VALID_ELEMENTS = [
	'@[style|title|aria-*|class]',
	'a[href|target|style|title|aria-*]',
	'img[src|alt|width|height|style|title|aria-*]',
	'embed[src]',
	'address',
	'article',
	'aside',
	'footer',
	'header',
	'h2',
	'h3',
	'h4',
	'h5',
	'h6',
	'hgroup',
	'nav',
	'section',
	'blockquote',
	'dd',
	'div',
	'dl',
	'dt',
	'figcaption',
	'figure',
	'hr',
	'li',
	'ol',
	'p',
	'pre',
	'ul',
	'abbr',
	'b',
	'br',
	'em',
	'i',
	'q',
	's',
	'small',
	'span',
	'strong',
	'sub',
	'sup',
	'time',
	'u',
	'var',
	'caption',
	'col',
	'colgroup',
	'table',
	'tbody',
	'td',
	'tfoot',
	'th',
	'thead',
	'tr',
];

export const TINYMCE_CONFIG = {
	base_url: '/tinymce',
	valid_elements: VALID_ELEMENTS.join(','),
	suffix: '.min',
	plugins: [
		'link',
		'lists',
		'table',
		'code',
		'image',
		'autoresize',
		'preview',
		'wordcount',
		'fullscreen',
		'charmap',
		'media',
	],
	branding: false,
	resize: true,
	browser_spellcheck: true,
	toolbar:
		'preview fullscreen | undo redo | formatselect | fontsizeselect | alignleft aligncenter alignright alignjustify | \
	 link | template hr | \
	 bold italic underline strikethrough superscript subscript | formats | removeformat forecolor backcolor | \
	 bullist numlist table charmap | cell row column | spellchecker code',
	toolbar_mode: 'wrap',
	statusbar: true,
	block_formats: 'Paragraph=p; Title=h2; header=h3; Subheader=h4',
	fontsize_formats: '8pt 10pt 12pt 14pt 16pt 18pt 24pt 36pt 48pt',
	menubar: 'view insert edit format table tools help',
	menu: {
		edit: { title: 'Edit', items: 'undo redo | selectall' },
		view: {
			title: 'View',
			items: 'preview fullscreen code | visualchars visualblocks | spellchecker',
		},
		insert: { title: 'Insert', items: 'image media inserttable | charmap hr | pagebreak nonbreaking anchor' },
		format: {
			title: 'Format',
			items: 'bold italic underline strikethrough superscript subscript | formats blockformats fontsizes align lineheight | forecolor backcolor | removeformat',
		},
		tools: { title: 'Tools', items: 'spellchecker spellcheckerlanguage | code wordcount' },
		table: { title: 'Table', items: 'inserttable | cell row column | tableprops deletetable' },
		help: { title: 'Help', items: 'help' },
	},
	relative_urls: false,
	remove_script_host: true,
	urlconverter_callback: (url: string) => url,
	target_list: [
		{ title: 'None', value: '' },
		{ title: 'Same page', value: '_self' },
		{ title: 'New page', value: '_blank' },
	],
	default_link_target: '_blank',
	promotion: false,
	paste_data_images: false,
};

export const TINYMCE_API_KEY = 'azxqxh1v22skfywk8cy23wykx7ozgjk535j4lx9swcf7hy8h';

export const TINYMCE: { CONFIG: any; API_KEY: string } = {
	CONFIG: TINYMCE_CONFIG,
	API_KEY: TINYMCE_API_KEY,
};
